import React, { useState, useEffect } from "react";
import {
  FiArrowRightCircle,
  FiTruck,
  FiXCircle,
  FiStar,
  FiChevronRight,
  FiPackage,
  FiCalendar,
  FiFilter,
} from "react-icons/fi";
import axios from "axios";
import { baseurl, imgurl } from "../baseurl";
import { Link } from "react-router-dom";
import Swal from "sweetalert2"; // Ensure this is imported at the top


function Orders() {
  const [orders, setOrders] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reviewModal, setReviewModal] = useState({
    show: false,
    product: null,
    orderId: null,
  });
  const [reviewData, setReviewData] = useState({ rating: 0, comment: "" });

  const customerId = localStorage.getItem("customerId");

  const fetchOrders = async () => {
    try {
      const { data } = await axios.get(`${baseurl}getOrdersByCustomerId/${customerId}`);
      if (data.success && Array.isArray(data.orders)) {
        setOrders(data.orders);
      } else {
        setOrders([]);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!customerId) return;
    fetchOrders();
  }, [customerId]);

  const filters = ["Confirmed", "Shipped", "Delivered", "Cancelled"];

  const handleFilterChange = (status) => {
    setSelectedFilters((prev) =>
      prev.includes(status) ? prev.filter((s) => s !== status) : [...prev, status]
    );
  };

  // --- NEW: CANCEL ORDER FUNCTION ---

const handleCancelOrder = async (orderId, uuid) => {
  const { value: formValues } = await Swal.fire({
    title: "Cancel Order",
    html: `
      <div class="swal-custom-container" style="text-align: left;">
        <label class="swal-custom-label" style="display: block; margin-bottom: 5px; font-weight: bold;">Reason for cancellation:</label>
        <select id="swal-select" class="swal-custom-input" style="width: 100%; padding: 8px; margin-bottom: 15px;">
          <option value="" disabled selected>Select a reason</option>
          <option value="Changed my mind">Changed my mind</option>
          <option value="Found a better price">Found a better price</option>
          <option value="Delivery time is too long">Delivery time is too long</option>
          <option value="Ordered by mistake">Ordered by mistake</option>
          <option value="Damaged OR Wrong Product">Damaged OR Wrong Product</option>
          <option value="Other">Other</option>
        </select>
        
        <label class="swal-custom-label" style="display: block; margin-bottom: 5px; font-weight: bold;">Additional Comments (Optional):</label>
        <textarea id="swal-textarea" class="swal-custom-textarea" placeholder="Type your message here..." style="width: 100%; height: 80px; padding: 8px; margin-bottom: 15px; resize: vertical;"></textarea>

        <label class="swal-custom-label" style="display: block; margin-bottom: 5px; font-weight: bold;">Upload Image (Optional):</label>
        <input type="file" id="swal-image" accept="image/*" style="width: 100%; margin-bottom: 15px;" />

        <label class="swal-custom-label" style="display: block; margin-bottom: 5px; font-weight: bold;">Upload Video (Optional):</label>
        <input type="file" id="swal-video" accept="video/*" style="width: 100%; margin-bottom: 15px;" />
      </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Cancel Order",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#e53e3e",
    cancelButtonColor: "#3182ce",
    reverseButtons: false,
    customClass: {
      popup: 'my-swal-popup',
      confirmButton: 'my-swal-confirm',
      cancelButton: 'my-swal-cancel'
    },
    preConfirm: () => {
      const reason = document.getElementById('swal-select').value;
      const comment = document.getElementById('swal-textarea').value;
      const imageFile = document.getElementById('swal-image').files[0];
      const videoFile = document.getElementById('swal-video').files[0];

      if (!reason) {
        Swal.showValidationMessage("Please select a reason");
        return false;
      }
      
      return { reason, comment, imageFile, videoFile };
    }
  });

  if (formValues) {
    try {
      // Show loading indicator
      Swal.fire({ title: "Processing...", didOpen: () => Swal.showLoading(), allowOutsideClick: false });

      // 🔄 Create FormData object to package text elements alongside raw file streams
      const formData = new FormData();
      formData.append("order_id", orderId);
      formData.append("order_uuid", uuid);
      formData.append("cancellation_reason", formValues.reason);
      formData.append("cancellation_comment", formValues.comment);
      
      // Append files if selected by user
      if (formValues.imageFile) {
        formData.append("image", formValues.imageFile);
      }
      if (formValues.videoFile) {
        formData.append("video", formValues.videoFile);
      }

      // 🔄 Put request sent with multipart header handling for files
      const response = await axios.put(`${baseurl}cancelOrder`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        Swal.fire("Cancelled!", "Your order has been cancelled.", "success");
        fetchOrders(); 
      } else {
        Swal.fire("Error", response.data.error || "Could not process request", "error");
      }
    } catch (err) {
      console.error("Cancel Order Error:", err);
      Swal.fire("Error", err.response?.data?.error || "Could not connect to server", "error");
    }
  }
};

  const filteredOrders =
    selectedFilters.length === 0
      ? orders
      : orders.filter((order) => selectedFilters.includes(order.order_status));

  const getStatusClass = (status) => {
    switch (status) {
      case "Delivered": return "status-delivered";
      case "Shipped": return "status-shipped";
      case "Cancelled": return "status-cancelled";
      case "Confirmed": return "status-confirmed";
      default: return "status-default";
    }
  };

  const openReviewModal = (orderId, product) => {
    setReviewModal({ show: true, product, orderId });
    setReviewData({ rating: 0, comment: "" });
  };

  const handleReviewSubmit = async () => {
    const payload = {
      order_id: reviewModal.orderId,
      product_id: reviewModal.product?.product_id,
      rating: reviewData.rating,
      comment: reviewData.comment.trim(),
      customer_id: customerId,
    };
    console.log("📝 Review Submitted:", payload);
    setReviewModal({ show: false, product: null, orderId: null });
  };

  return (
    <div className="orders-wrapper bg-light min-vh-100 pb-5">
      {/* Breadcrumb Header */}
      <div className="bg-white border-bottom mb-4">
        <div className="container py-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-1 small">
              <li className="breadcrumb-item"><Link to="/" className="text-decoration-none">Home</Link></li>
              <li className="breadcrumb-item active">My Orders</li>
            </ol>
          </nav>
          <h4 className="fw-bold mb-0">My Orders</h4>
        </div>
      </div>

      <div className="container">
        <div className="row g-4">
          {/* Sidebar Filters */}
          <div className="col-lg-3">
            <div className="filter-sidebar card border-0 shadow-sm p-3 sticky-top" style={{ top: "20px" }}>
              <div className="d-flex align-items-center mb-3">
                <FiFilter className="me-2 text-primary" />
                <h6 className="fw-bold mb-0">Filters</h6>
              </div>
              <div className="filter-options">
                {filters.map((f) => (
                  <label key={f} className="filter-label d-flex align-items-center p-2 rounded mb-1">
                    <input
                      type="checkbox"
                      className="form-check-input me-3"
                      checked={selectedFilters.includes(f)}
                      onChange={() => handleFilterChange(f)}
                    />
                    <span className="small fw-medium">{f}</span>
                  </label>
                ))}
              </div>
              {selectedFilters.length > 0 && (
                <button className="btn btn-link btn-sm text-danger text-decoration-none mt-2 p-0" onClick={() => setSelectedFilters([])}>
                  Clear All Filters
                </button>
              )}
            </div>
          </div>

          {/* Orders List */}
          <div className="col-lg-9">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-grow text-primary" role="status"></div>
                <p className="mt-2 text-muted">Fetching your orders...</p>
              </div>
            ) : filteredOrders.length === 0 ? (
              <div className="text-center py-5 bg-white rounded shadow-sm">
                <FiPackage size={50} className="text-muted mb-3" />
                <h5>No orders to display</h5>
                <p className="text-muted">Try changing your filters or start shopping!</p>
                <Link to="/shop" className="btn btn-primary rounded-pill px-4">Browse Products</Link>
              </div>
            ) : (
              filteredOrders.map((order) => (
                <div key={order.order_id} className="order-card-v2 card border-0 shadow-sm mb-4">
                  {/* Order Header */}
                  <div className="card-header bg-transparent py-3 px-4 border-bottom d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div className="order-icon-box">
                        <FiPackage />
                      </div>
                      <div>
                        <div className="fw-bold text-dark">Order #{order.order_uuid?.slice(0, 8).toUpperCase()}</div>
                        <div className="text-muted x-small d-flex align-items-center gap-1">
                          <FiCalendar /> {new Date(order.created_at).toLocaleDateString("en-IN", { day: 'numeric', month: 'short', year: 'numeric' })}
                        </div>
                      </div>
                    </div>
                    <div className={`status-badge ${getStatusClass(order.order_status)}`}>
                      {order.order_status}
                    </div>
                  </div>

                  {/* Order Items */}
                  <div className="card-body p-4">
                    {order.items?.map((item, idx) => (
                      <div key={idx} className="order-item-row d-flex align-items-center mb-4 last-child-mb-0">
                        <div className="product-img-wrapper">
                          <img src={`${imgurl}${item.product_image}`} alt={item.product_data?.name} />
                        </div>
                        <div className="ms-3 flex-grow-1">
                          <h6 className="mb-1 fw-bold text-truncate" style={{ maxWidth: "300px" }}>
                            {item.product_data?.name}
                          </h6>
                          <div className="d-flex align-items-center gap-3 text-muted x-small">
                            <span>Qty: <strong>{item.item_quantity || 1}</strong></span>
                            <span>Price: <strong>₹{Number(item.product_data?.price || 0).toLocaleString()}</strong></span>
                          </div>
                          {order.order_status === "Delivered" && (
                            <button className="btn btn-link btn-sm p-0 mt-1 x-small text-primary fw-bold text-decoration-none d-flex align-items-center" onClick={() => openReviewModal(order.order_id, item.product_data)}>
                              <FiStar className="me-1" /> Rate & Review Product
                            </button>
                          )}
                        </div>
                        <div className="text-end d-none d-md-block">
                           <FiChevronRight className="text-muted" />
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Order Footer */}
                  <div className="card-footer bg-white border-top p-3 px-4 d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="total-section">
                      <span className="text-muted small">Grand Total:</span>
                      <span className="h6 fw-bold text-dark ms-2 mb-0">₹{order.totals?.total_amount.toLocaleString()}</span>
                    </div>
                    <div className="action-btns d-flex gap-2">
                      <Link to={`/invoice/${order.order_uuid}`} className="btn btn-sm btn-dark rounded-pill px-3 d-flex align-items-center">
                        <FiArrowRightCircle className="me-1" /> View Invoice
                      </Link>

                      {/* --- UPDATED: CANCEL BUTTON LOGIC --- */}
                      {order.order_status === "Confirmed" && (
                        <button 
                          className="btn btn-sm btn-outline-danger rounded-pill px-3"
                          onClick={() => handleCancelOrder(order.order_id,order.order_uuid )}
                        >
                          Cancel Order
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      {/* Review Modal */}
      {reviewModal.show && (
        <div className="custom-modal-overlay">
          <div className="custom-modal card shadow-lg p-4 animate-slide-up">
            <div className="d-flex justify-content-between align-items-start mb-3">
                <h5 className="fw-bold">Write a Review</h5>
                <FiXCircle className="text-muted cursor-pointer" size={24} onClick={() => setReviewModal({ show: false, product: null, orderId: null })} />
            </div>
            <p className="text-muted small mb-4">How was your experience with <strong>{reviewModal.product?.name}</strong>?</p>

            <div className="star-rating mb-4 d-flex justify-content-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <FiStar
                  key={star}
                  size={32}
                  className={`star-icon ${reviewData.rating >= star ? 'active' : ''}`}
                  onClick={() => setReviewData((r) => ({ ...r, rating: star }))}
                />
              ))}
            </div>

            <textarea
              className="form-control rounded-3 mb-4"
              rows="4"
              placeholder="Tell others what you loved or didn't..."
              value={reviewData.comment}
              onChange={(e) => setReviewData((r) => ({ ...r, comment: e.target.value }))}
            />

            <div className="d-flex gap-2">
              <button className="btn btn-light flex-grow-1 fw-bold py-2" onClick={() => setReviewModal({ show: false, product: null, orderId: null })}>Close</button>
              <button className="btn btn-primary flex-grow-1 fw-bold py-2" onClick={handleReviewSubmit}>Submit Review</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .x-small { font-size: 11px; }
        .cursor-pointer { cursor: pointer; }
        .order-card-v2 { transition: 0.3s cubic-bezier(.25,.8,.25,1); border-radius: 12px !important; }
        .order-card-v2:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important; }
        
        .order-icon-box { width: 40px; height: 40px; background: #f0f4ff; color: #4361ee; display: flex; align-items: center; justify-content: center; border-radius: 10px; font-size: 18px; }
        
        .status-badge { padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; }
        .status-confirmed { background: #e0f2ff; color: #0077ff; }
        .status-shipped { background: #fff4e5; color: #ff9900; }
        .status-delivered { background: #e6ffed; color: #22c55e; }
        .status-cancelled { background: #ffebeb; color: #ef4444; }
        
        .product-img-wrapper { width: 70px; height: 70px; border-radius: 10px; overflow: hidden; background: #f8f9fa; border: 1px solid #eee; }
        .product-img-wrapper img { width: 100%; height: 100%; object-fit: cover; }
        
        .filter-sidebar { border-radius: 12px !important; }
        .filter-label { transition: 0.2s; cursor: pointer; }
        .filter-label:hover { background: #f1f5f9; }
        
        .custom-modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(4px); }
        .custom-modal { width: 100%; max-width: 420px; border-radius: 20px !important; margin: 15px; }
        
        .star-icon { cursor: pointer; color: #cbd5e1; transition: 0.2s; }
        .star-icon.active { color: #ffc107; fill: #ffc107; }
        
        .animate-slide-up { animation: slideUp 0.3s ease-out; }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

        @media (max-width: 768px) {
          .order-item-row { flex-direction: column; align-items: flex-start !important; }
          .product-img-wrapper { width: 100%; height: 150px; margin-bottom: 10px; }
          .ms-3 { margin-left: 0 !important; }
          .action-btns { width: 100%; }
          .action-btns button { flex: 1; font-size: 10px; }
        }



        /* Container for the fields */
.swal-custom-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Aligns labels to the left */
  padding: 10px 0;
  overflow: hidden; /* Removes the bottom scrollbar */
}

/* Label styling */
.swal-custom-label {
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 8px;
  margin-top: 10px;
}

/* Select dropdown styling */
.swal-custom-input {
  width: 100%;
  height: 45px;
  padding: 0 10px;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
}

/* Textarea styling */
.swal-custom-textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical; /* Allows user to drag down but not side to side */
  outline: none;
}

/* Removing default Swal padding that causes scrollbars */
.my-swal-popup {
  width: 500px !important; /* Fixed width to prevent shrinking */
  padding: 2rem !important;
  border-radius: 8px !important;
}

/* Button spacing adjustments */
.my-swal-confirm, .my-swal-cancel {
  padding: 12px 25px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  margin: 10px 5px !important;
}
  
      `}</style>
    </div>
  );
}

export default Orders;